import Spinner from "@/components/Spinner";
import {
  PATH_PAYROLL_INSPECTION,
  PATH_PAYROLL_PREVIEW,
  PATH_PAYROLL_SPLIT,
} from "@/constants";
import { usePayrollParams } from "@/modules/payrolls/hooks/usePayrollParams";
import { usePayrollQuery } from "@/modules/payrolls/hooks/usePayrollQuery";
import {
  PAYROLL_STATUS_CLOSED,
  PAYROLL_STATUS_CREATED,
  PAYROLL_STATUS_SPLIT,
} from "@/schemas/payroll";
import { memo } from "react";
import { generatePath, Navigate } from "react-router-dom";

const getPathBasedOnStatus = (status?: string) => {
  switch (status) {
    case PAYROLL_STATUS_CREATED:
    case PAYROLL_STATUS_CLOSED:
      return PATH_PAYROLL_INSPECTION;
    case PAYROLL_STATUS_SPLIT:
      return PATH_PAYROLL_SPLIT;
    default:
      return PATH_PAYROLL_PREVIEW;
  }
};

export const PayrollStatusBasedRedirect = memo(() => {
  const { payrollId } = usePayrollParams();
  const query = usePayrollQuery(payrollId);

  if (query.isLoading) {
    return <Spinner className="w-full h-full" />;
  }

  return (
    <Navigate
      to={generatePath(getPathBasedOnStatus(query?.data?.payroll_status), {
        payrollId,
      })}
      replace
    />
  );
});
